const getApiResponseMessage = (error: {
  graphQLErrors?: ReadonlyArray<{ extensions?: { response?: { body?: { message: string } } } }>;
}): string | undefined => error.graphQLErrors?.[0]?.extensions?.response?.body?.message;

export { getApiResponseMessage };
